import { AudioHelper } from "Helpers/AudioHelper";

export const audios = [
        AudioHelper.Start_Game_Countdown,
        AudioHelper.Card_and_Answer_Selection,
        AudioHelper.Card_Flip_2nd_sound,
        AudioHelper.Card_Transfer_Deck_to_Across_Screen_slow_down,
        AudioHelper.Energy_Quiz_Correct_Answer_1st_sound,
        AudioHelper.Energy_Quiz_Incorrect_Answer_1st_sound,
        AudioHelper.Saver_Correct_Quiz_Renewable_Energy_card_Points,
        AudioHelper.Waster_Dirty_Energy_Points_2nd_sound,
        AudioHelper.Renewable_Energy_card_chee_hoo,
        AudioHelper.Fossil_Fuel_card_points_floating_card_in_middle_of_screen_until_points_are_processed,
        AudioHelper.Peak_Load,
        AudioHelper.Game_Won_Crowd_Cheering_0_6_sec,
        AudioHelper.Game_Lost_Sad_Trombone];
